import { render, staticRenderFns } from "./EditNote.vue?vue&type=template&id=450bdaf7&"
import script from "./EditNote.vue?vue&type=script&lang=js&"
export * from "./EditNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('450bdaf7')) {
      api.createRecord('450bdaf7', component.options)
    } else {
      api.reload('450bdaf7', component.options)
    }
    module.hot.accept("./EditNote.vue?vue&type=template&id=450bdaf7&", function () {
      api.rerender('450bdaf7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/requests/detailPages/supplierDetailPages/EditNote.vue"
export default component.exports